

























import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  TimelineMax,
  CSSPlugin,
  CSSRulePlugin,
  ScrollToPlugin,
  Draggable,
  Power4,
  Expo,
  Elastic,
  Bounce,
  onComplete,
  clearProps,
  TweenMax,
  fromTo
} from 'gsap/all';

import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';

@Component({
  name: 'AirFreight'
})
export default class AirFreight extends Vue {
  // @Prop() private msg!: string;

  public imageReveal() {
    const verticalImg = document.querySelector('.img-left');
    const horizontalImg = document.querySelector('.img-right');
    const logiPara = document.querySelector('.text-content > p');
    const logiBtn = document.querySelector('.text-content > a');

    let logisticTl = new TimelineMax({});

    logisticTl
      .fromTo(
        verticalImg,
        1.5,
        { xPercent: -100, opacity: 1 },
        { xPercent: 0, ease: Expo.easeInOut, opacity: 1 }
      )
      .fromTo(
        horizontalImg,
        1.5,
        { xPercent: 100, opacity: 1 },
        { xPercent: 0, ease: Expo.easeInOut, opacity: 1 },
        '-=1.5'
      )
      .fromTo(
        logiPara,
        1.3,
        { yPercent: 100, opacity: 0 },
        { yPercent: 0, opacity: 1, ease: Expo.easeOut },
        '-=1.3'
      )
      .fromTo(
        logiBtn,
        1.3,
        { yPercent: 100, opacity: 0 },
        { yPercent: 0, opacity: 1, ease: Expo.easeOut },
        '-=1.1'
      );

    const controller = new ScrollMagic.Controller();

    const scene: any = new ScrollMagic.Scene({
      triggerElement: '.tab-component',
      reverse: false,
      triggerHook: 'onCenter'
    })
      .setTween(logisticTl)
      .addTo(controller);
  }

  public mounted() {
    this.imageReveal();
  }
}
